import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  h3 {
    font-style: unset;
  }

  @media all and (max-width: 1200px) {
    margin-top: 2em;
   }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  &:first-of-type {
    border-right: 1px solid darkslategray;
  }

  h3 {
    text-align: center;
    color: #3ee9f7;
    margin-bottom: 10px;

    &.yellow {
      color: #b5f92d;
    }

    &.red {
      color: #ff0033;
    }
  }

  p {
    font-size: 20px;
    color: white;
    margin: 5px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/ComparisonLists/ComparisonLists.styles.ts